<script setup>
    import { computed, ref } from "@vue/reactivity";
    import DatePicker from "./date-picker.vue";
    import { Delete, Right, RefreshRight, Refresh, Filter } from "@element-plus/icons-vue";
    import { storeToRefs } from "pinia";
    import { useMailLogStore} from "../stores/maillog";
    import mailForward from "./mail-forward.vue";
    import mailResend from "./mail-resend.vue";
    import filters from "./filters.vue";

    const store = useMailLogStore();
    const centerDialogVisible = ref(false);   
    const showFilter = ref(false);
    const { selectedItems, disableDelete, disableSingleSelectActions, isLoading,singleMailSelectedData } = storeToRefs(store);

    function refresh(){
        store.fetchLogs();
    }

    function handleDelete(){
        store.deleteLog();
    }
    const closeClick = (e) => {
        showFilter.value = !showFilter.value;
    }

</script>
<template>
    <div>
    <div class="wml-control-wrapper">
        <div class="wml-left-actions">
            <DatePicker />
            <div class="wml-action-wrapper">

                <el-popconfirm
                    width="220"
                    confirm-button-text="OK"
                    cancel-button-text="No, Thanks"
                    icon=""
                    title="Are you sure to delete this?"
                    @confirm="handleDelete"
                >
                    <template #reference>
                        <el-button title="Delete" type="primary" :disabled="disableDelete" :icon="Delete" circle />
                    </template>
                </el-popconfirm> 
                
                <mailForward />
                <mailResend />
                <el-button title="Filter" :icon="Filter" type="primary" @click="showFilter = !showFilter" circle />
            </div>
        </div>

        <div class="wml-right-actions">
            <el-button :loading="isLoading" type="primary" @click="refresh" :icon="Refresh" circle />
        </div>
        
    </div>
    
    <filters v-if="showFilter" :closeClick="closeClick" />
</div>

</template>
<style>
#wml-content .wml-control-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    margin: 10px 0;
    padding: 10px;
    background-color: #fff;
    border: 1px solid #ccd0d4;
    border-radius: 3px;
    justify-content: space-between;
}
</style>